import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { NavController } from '@ionic/angular/standalone';

import { AuthService } from '@core/auth/services/auth.service';

export const loginGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const navCtrl = inject(NavController);

  const isAuthenticated = await authService.checkAuthentication();

  if (isAuthenticated) {
    await navCtrl.navigateForward(['home']);
    return false;
  }

  return true;
};
